import React, { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import { BLOG_POSTS } from "./posts";

const OtherBlogs = ({ currentSlug }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filtered = useMemo(() => {
    return BLOG_POSTS
      .filter((p) => p.slug !== currentSlug) // Exclude current blog post
      .filter((p) =>
        p.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .slice(0, 10); // Show only first 10 blogs
  }, [searchTerm, currentSlug]);

  return (
    <aside className="p-3 rounded-3" style={{ background: "#f8f9fa" }}>
      <div className="mb-3">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control"
          placeholder="Search other posts..."
          aria-label="Search other posts"
        />
      </div>
      <h5 className="text-dark mb-3">Other Blogs</h5>
      <ul className="list-unstyled m-0">
        {filtered.length === 0 && <li className="text-muted">No results</li>}
        {filtered.map((post) => (
          <li key={post.slug} className="mb-3">
            <NavLink to={post.slug} className="text-decoration-none d-flex gap-3 align-items-start">
              <img
                src={post.image || "/assets/images/logo.png"}
                alt={post.title}
                className="rounded-2"
                style={{ width: "84px", height: "64px", objectFit: "cover" }}
              />
              <div className="d-flex flex-column">
                <span className="text-dark fw-semibold lh-sm">{post.title}</span>
                {post.date && (
                  <small className="text-muted mt-1">
                    {new Date(post.date).toLocaleDateString("en-GB", {
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                    })}
                  </small>
                )}
              </div>
            </NavLink>
          </li>
        ))}
      </ul>
      <div className="d-flex justify-content-center mt-4">
        <NavLink to="/blogs" className="btn bg-primary text-dark">
          All Blogs
        </NavLink>
      </div>
    </aside>
  );
};

export default OtherBlogs;


